import NarinLayout from "components/NarinLayout";
import ReadOnlyLayout from "components/Desktop/ReadOnlyLayout";
import CardItem from "./components/CardItem";

const WhyBuyFrom = () => {
  const listItem = [
    {
      title: "ส่งสินค้าทุกชนิด ",
      description:
        "เราส่งสินค้าทุกชนิด ทั้งของเหลว สินค้าหนัก สินค้าชิ้นใหญ่ เช่น เตียง , รถเข็น , Syringe , เกลือแร่ เป็นต้น",
      icon: <img src="/logistics.png" height={48} width={48} />,
    },
    {
      title: "คืนสินค้า 100%",
      description:
        "เรารับเปลี่ยนคืนสินค้า 100% ทั้งกรณีสินค้า เสียหายจากการขนส่ง หรือสินค้าหมดอายุ",
      icon: <img src="/refund.png" height={40} width={40} />,
    },
    // {
    //   title: "เช็คค่าส่งได้รวดเร็ว",
    //   description: "ท่านสามารถทราบค่าส่งได้ทันทีที่หน้าเว็บไซต์ ไม่ต้องรอทางร้านแจ้ง ทำให้ท่านบริหารต้นทุนได้อย่างรวดเร็ว",
    //         icon:<img src"logistics.png"url} height={48} width={48} /> ,

    // },
    {
      title: "เก็บคะแนนรูปแบบ Point",
      description:
        "ทุกๆยอดการสั่งซื้อของท่านจะไม่สูญเปล่า เรามีระบบเก็บคะแนนในรูปของ Pointบันทึกในระบบอัตโนมัติทุกยอดการสั่งซื้อของท่าน",
      icon: <img src="/star.png" height={60} width={60} />,
    },
    {
      title: "จัดหาสินค้าให้ถึงมือ",
      description:
        "สินค้าใดที่เราไม่มีขาย เราสามารถจัดหาให้ท่านได้ผ่านระบบหน้าเว็บได้อย่างสะดวกสบาย",
      icon: <img src="/drug.png" height={40} width={40} />,
    },
    {
      title: "แยกหมวดหมู่สินค้าชัดเจน",
      description:
        "เราแยกหมวดหมู่สินค้าได้ชัดเจนให้ท่านสามารถเลือกดูได้อย่างสะดวกสบาย",
      icon: <img src="/categories.png" height={40} width={40} />,
    },
    {
      title: "ข้อมูลครบถ้วน",
      description:
        "ท่านสามารถดูข้อมูลสินค้า รูปสินค้า และราคา ได้ที่หน้าเว็บไซต์ได้ตลอดเวลา ข้อมูลครบถ้วน",
      icon: <img src="/medical.png" height={40} width={40} />,
    },
    // {
    //   title: "แสดงจำนวนสินค้าแบบเรียลไทม์",
    //   description: "ท่านสามารถรู้ได้ทันทีว่าสินค้าตัวใดมีสินค้าหรือ สินค้าหมด",
    //   icon: <img src="/out-of-stock.png" height={40} width={40} />,
    // },
    {
      title: "ดูประวัติย้อนหลังได้",
      description:
        "ท่านสามารถดูประวัติการสั่งซื้อย้อนหลังได้ตลอดเวลาผ่านระบบสมาชิกทางหน้าเว็บไซต์",
      icon: <img src="/file.png" height={40} width={40} />,
    },
    {
      title: "สามารถบันทึกสินค้าได้ใน List",
      description:
        "เรามีระบบให้ท่านสามารถบันทึกสินค้าที่ใช้บ่อยไว้ใน List ของท่านเอง เพื่อความสะดวกในการสั่งซื้อสินค้าตัวเดิม",
      icon: <img src="/checklist.png" height={40} width={40} />,
    },
    {
      title: "บริการอย่างมืออาชีพ",
      description:
        "เราบริการอย่างมืออาชีพด้วยความรวดเร็ว หากพนักงานติดต่อกลับล่าช้า ไม่สุภาพ ให้ข้อมูลไม่ครบถ้วน หรือติดขัดปัญหาด้านใด มีระบบบริการท่านในการแจ้งปัญหา ติชม แนะนำ ได้ทันที หน้าเว็บไซต์ การติชมของท่านจะถูกส่งตรงสู่ผู้บริหารและนำไปปรับปรุงเสมอ",
      icon: <img src="/chat.png" height={40} width={40} />,
    },
  ];
  return (
    <NarinLayout>
      <ReadOnlyLayout title="ทำไมต้องซื้อกับนรินทร์เภสัช">
        <div className="grid grid-cols-4 gap-4">
          {listItem.map((item) => (
            <CardItem key={item.title} data={item} />
          ))}
        </div>
      </ReadOnlyLayout>
    </NarinLayout>
  );
};

export default WhyBuyFrom;
